import React, { useState } from 'react';
import { fetchApiData, interpolate } from '../../Utils/ApiCalls';
import { DropdownMenu, showToast } from '@attentive-platform/stem-ui';
import { PORTFOLIO_REVIEW_ENUM } from '../../Constants/Constants';
import { PORTFOLIO_EXECUTE } from '../../urls';
import FalconUserAssignModal from './FalconUserAssignModal';

function PortfolioReviewAction({ row, refetchData }) {
  const menuItems = [
    { value: PORTFOLIO_REVIEW_ENUM.FALCON, label: 'Run On Falcon' },
    { value: PORTFOLIO_REVIEW_ENUM.FLOCK, label: 'Run On Flock' }
  ];
  const portfolioId = row?.original.id;
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const handleMenuClick = async (e, item) => {
    if (item.value === PORTFOLIO_REVIEW_ENUM.FALCON) {
      setShow(true);
    } else if (item.value === PORTFOLIO_REVIEW_ENUM.FLOCK) {
      try {
        await fetchApiData({
          endpoint: interpolate(PORTFOLIO_EXECUTE, [portfolioId]),
          apiRequest: 'POST',
          data: {
            execute_on: PORTFOLIO_REVIEW_ENUM.FLOCK
          }
        });
        showToast('Portfolio review for Flock started successfully', 'success');
        await refetchData();
      } catch (error) {
        showToast(error, 'error');
      }
    }
  };

  return (
    <>
      <DropdownMenu
        color='secondary'
        open={open}
        menuItems={menuItems}
        onButtonClick={() => setOpen(prevState => !prevState)}
        handleClose={() => setOpen(false)}
        onMenuItemClick={handleMenuClick}
        variant='outlined'
        IconDropdown
      />
      <FalconUserAssignModal show={show} setShow={setShow} refetchData={refetchData} portfolioId={portfolioId} />
    </>
  );
}

export default PortfolioReviewAction;
